import { StatusBar } from "expo-status-bar";
import React from "react";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  TextInput,
  ActivityIndicator,
  Platform,
  Alert,
  FlatList,
  TouchableWithoutFeedback,
  Dimensions,
} from "react-native";
import ENV from "app/utils/ENV";
import Text from "app/components/Text";
import valueActions from "app/utils/valueActions";
import textHelpers from "app/utils/textHelpers";
import valueHelpers from "app/utils/valueHelpers";
import timeHelpers from "app/utils/timeHelpers";
import colorHelpers from "app/utils/colorHelpers";
import * as RootNavigation from "app/utils/RootNavigation.js";
import {
  styleSheet,
  HEIGHT,
  CHILD_RATIO,
  PARENT_RATIO,
} from "app/utils/styleSheet";
import Hoverable from "app/components/Hoverable";

// let WIDTH = Dimensions.get("window").width;

import MomentBullet from "app/components/chapter/MomentBullet";

import {
  Ionicons,
  Feather,
  AntDesign,
  FontAwesome,
  MaterialIcons,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

import store from "app/redux/store";
import { progress, create } from "app/actions/values";

import { StyleContext } from "app/contexts/Style";

export default class MomentTimeline extends React.Component {
  static contextType = StyleContext;
  constructor(props) {
    super(props);

    this.state = {
      recursive: false,
      // pastRevisions: false,
      events: [],
      startAt: null,
      endAt: null,
      range: 0,
      key: 0,
      slots: [],
      expandedDates: [],
      zoomedOut: false,
      loadingRevisions: false,
      averageSpan: "-",
      allRevisions: false,
      showChapters: false,
      chapterSlots: [],
    };
  }

  componentDidMount = () => {
    this.generateSlots();
  };

  componentDidUpdate = (prevProps) => {
    if (
      prevProps.allRevisions != this.props.allRevisions ||
      !textHelpers.compareObjects(prevProps.value, this.props.value)
    ) {
      this.generateSlots();
    }
  };

  generateSlots = async () => {
    // let { value, allRevisions } = this.props;
    let { value } = this.props;
    let { recursive, key } = this.state;
    let { allRevisions } = this.state;

    // if (allRevisions) value = valueHelpers.condenseRevisions(value);

    let events = valueHelpers.getTimeline(value, recursive);
    if (allRevisions) {
      let revisions = valueHelpers.getRevisions(value);
      for (let r of revisions) {
        events = [...events, ...valueHelpers.getTimeline(r, recursive)];
      }
    }
    events = textHelpers.uniq(events, "event_id");
    events = textHelpers.oldestFirst(events, "timestamp");
    // events = events.reverse();
    console.log("timeline events:", events);

    let { slots, startAt, endAt, range, averageSpan } =
      this.formatSlots(events);

    this.setState({
      events,
      startAt,
      endAt,
      range,
      slots,
      averageSpan,
      // key: key + 1,
    });
  };

  formatSlots = (events) => {
    let { value } = this.props;

    let startAt = value.created_at;
    if (!!events?.length) {
      let firstEvent = events[0];
      let eStartAt = firstEvent.timestamp;
      if (!startAt || eStartAt < startAt) startAt = eStartAt;
      // startAt = timeHelpers.beginningOfMonth(startAt);
    }
    startAt = timeHelpers.dateTimeToDate(startAt);

    let endAt = value.completed_at || new Date();
    if (!!events?.length) {
      let lastEvent = events[0];
      let eEndAt = lastEvent.timestamp;
      if (!endAt || eEndAt > endAt) endAt = eEndAt;
    }
    endAt = timeHelpers.dateTimeToDate(endAt);

    let range = Math.ceil(timeHelpers.daysAgo(startAt, endAt));

    if (range < 6) {
      let diff = 6 - range;
      let startAtDiff = Math.floor(diff / 2);
      let endAtDiff = Math.ceil(diff / 2);
      startAt = timeHelpers.tomorrow(startAt, -startAtDiff);
      startAt = timeHelpers.dateTimeToDate(startAt);
      endAt = timeHelpers.tomorrow(endAt, -endAtDiff);
      endAt = timeHelpers.dateTimeToDate(endAt);
      range = 6;
    }

    let gaps = [];
    let lastEventDay = null;

    let slots = [];
    let cushionDays = Math.min(4, Math.floor(range / 7)); // 1 day for each 1 week
    let start = 0 - cushionDays;
    let end = range + cushionDays;
    for (let i = start; i <= end; i++) {
      let slotDate = timeHelpers.tomorrow(startAt, i);
      slotDate = timeHelpers.dateTimeToDate(slotDate);
      let dateEvents = events.filter((ev) => {
        // let evTs = ev.completed_at || ev.created_at;
        let evTs = ev.timestamp;
        let evDate = timeHelpers.dateTimeToDate(evTs);
        if (evDate == slotDate) {
          return true;
        } else {
          return false;
        }
      });
      if (!!dateEvents.length) {
        if (!!lastEventDay) {
          gaps.push(timeHelpers.daysApart(slotDate, lastEventDay));
        }
        lastEventDay = slotDate;
      }
      slots.push({
        date: slotDate,
        events: dateEvents,
        cushion: i < 0 || i > range,
      });
    }
    // slots = slots.reverse(); // reverse if using the inverted FlatList
    // console.log("SLOTS", slots, events.length);
    let averageSpan = !gaps.length
      ? "n/a"
      : gaps.reduce((a, b) => a + b) / gaps.length;

    return { events, slots, startAt, endAt, range, averageSpan };
  };

  render() {
    let { value } = this.props;
    let {
      recursive,
      pastRevisions,
      events,
      startAt,
      endAt,
      range,
      slots,
      expandedDates,
      zoomedOut,
      loadingRevisions,
      fetchingInheritance,
      averageSpan,
      allRevisions,
      showChapters,
    } = this.state;

    let hasChildren = !!valueHelpers.getChildren({ value, includeNotes: true })
      .length;
    let hasRevisions = value.id != value.root_id;
    let allowZoom = slots.length * 20 > this.context.sizes.WIDTH;

    let progressiveEvents = events.filter(
      (e) => !["creation", "note"].includes(e.category),
    );

    return (
      <View style={[this.styles().contentRow]}>
        <View style={this.styles().header}>
          <View style={this.styles().headerSection}>
            <Text
              bold
              onPress={() => {
                // WIDTH = Dimensions.get("window").width;
              }}
            >
              Timeline
            </Text>

            <Text> | </Text>

            <Text>{range} days</Text>

            <Text> | </Text>

            <Text>
              {progressiveEvents.length} event
              {progressiveEvents.length != 1 && "s"}
            </Text>
          </View>

          <View style={this.styles().headerSection}>
            {!!hasChildren && !value.id == "journal" && (
              <Text
                button={!recursive}
                selectedButton={recursive}
                onPress={async () => {
                  // WIDTH = Dimensions.get("window").width;
                  await this.setState({ recursive: !recursive });
                  await this.fetchInheritance();
                  this.generateSlots();
                }}
              >
                {recursive ? "Only show immediate" : "Show inherited"}{" "}
                {fetchingInheritance && <ActivityIndicator size="small" />}
              </Text>
            )}

            <Text
              button
              onPress={async () => {
                let newShowChapters = !showChapters;
                this.setState({
                  showChapters: newShowChapters,
                  loadingChapters: newShowChapters,
                });
                if (newShowChapters) {
                  let res = await valueActions.fetchMoments(value.id);
                  if (res.success) {
                    let moments = res.moments.map((m) => ({
                      ...m,
                      value,
                      timestampe: m.completed_at || m.created_at,
                    }));
                    let chapterSlots = this.formatSlots(moments).slots;
                    console.log("chapter slots", chapterSlots);
                    await this.setState({
                      loadingChapters: false,
                      chapterSlots,
                      moments,
                      chapters: res.chapters,
                      momentTimestamps: res.timestamps,
                    });
                  }
                }
              }}
            >
              {showChapters ? "Hide" : "Show"} Chapters
            </Text>
          </View>
        </View>

        <View style={this.styles().timeline}>
          <Text>Created: {timeHelpers.dateTimeToDate(value.created_at)}</Text>
          {/*<View style={this.styles().line} />*/}
          <View style={{ flex: 1 }} />
          <Text>{endAt}</Text>
        </View>

        <ScrollView
          horizontal
          style={{
            width: this.context.sizes.WIDTH,
            // maxHeight: showChapters ? 400 : 200,
            flex: 1,
            borderWidth: 2,
          }}
          contentContainerStyle={{
            flexGrow: 1,
            flexDirection: "column",
            width: zoomedOut ? this.context.sizes.WIDTH : undefined,
          }}
        >
          {showChapters && this.renderChapters()}
          {/*this.renderSlots(slots)*/}
          {this.renderEvents(events)}
        </ScrollView>
      </View>
    );
  }

  renderEvents = (events) => {
    return (
      <View style={{ padding: this.context.sizes.large }}>
        {events.map((event, i) => {
          let date = timeHelpers.dateTimeToDate(event.timestamp);
          return (
            <View
              key={event.event_id}
              style={{
                flexDirection: "row",
                alignItems: "center",
                zIndex: 9999 - i,
              }}
            >
              <Text
                bold
                onPress={(e) => {
                  RootNavigation.push("Chapters", { date }, e);
                }}
              >
                • {date}
              </Text>
              <MomentBullet
                showIcon
                smallBadge
                moment={event}
                category={event.category}
                // hideText
                expanded={false}
                stackTags
                // onExpand={() => this.expandSlot(item)}
                // onCollapse={() => this.collapseSlot(item)}
                noteIcon
                showTooltip
                noActions
                tooltipText={this.tooltipText(event)}
                asyncMoment
                // tooltipOptions={{
                //   rightAligned:
                //     index > slots.length / 2 ? true : false,
                // }}
              />
            </View>
          );
        })}
      </View>
    );
  };

  renderSlots = (slots) => {
    let { value } = this.props;
    let {
      recursive,
      pastRevisions,
      events,
      startAt,
      endAt,
      range,
      expandedDates,
      zoomedOut,
      loadingRevisions,
      fetchingInheritance,
      averageSpan,
      allRevisions,
    } = this.state;

    return (
      <View style={{ madingBottom: this.context.sizes.large }}>
        <View
          style={{ flexDirection: "row", ...StyleSheet.absoluteFillObject }}
        >
          {slots.map((item, index) => {
            let isExpanded = expandedDates.includes(item.date);
            return (
              <View
                key={index}
                style={[
                  this.styles().timeSlot,
                  !zoomedOut && { minWidth: 20 },
                  // !!(index % 2) && !item.cushion && this.styles().timeSlotAlt,
                  !!(index % 2) && this.styles().timeSlotAlt,
                  isExpanded && this.styles().expandedTimeSlot,
                  // !!expandedDates?.length &&
                  //   !isExpanded && { flexGrow: 0 },
                ]}
              />
            );
          })}
        </View>

        <View
          style={{
            flex: 1,
            flexDirection: "row",
            // ...StyleSheet.absoluteFillObject,
          }}
        >
          {slots.map((item, index) => {
            let events = item.events;
            let isExpanded = expandedDates.includes(item.date);
            return (
              <TouchableWithoutFeedback
                onPress={() => alert(item.date)}
                key={index}
              >
                <Hoverable onHoverIn={() => null} onHoverOut={() => null}>
                  {(isHovered) => {
                    return (
                      <View
                        style={[
                          this.styles().timeSlot,
                          !zoomedOut && { minWidth: 20 },
                          // !!(index % 2) && this.styles().timeSlotAlt,
                          { zIndex: 999 - index },
                          isExpanded && this.styles().expandedTimeSlot,
                          // !!expandedDates?.length &&
                          //   !isExpanded && { flexGrow: 0 },
                          // isHovered && this.styles().timeSlotHover,
                        ]}
                      >
                        {events.map((event, i) => {
                          return (
                            <View
                              key={event.event_id}
                              style={{ zIndex: 999 - i }}
                            >
                              <MomentBullet
                                showIcon
                                smallBadge
                                moment={event}
                                category={event.category}
                                hideText
                                expanded={false}
                                stackTags
                                onExpand={() => this.expandSlot(item)}
                                onCollapse={() => this.collapseSlot(item)}
                                noteIcon
                                showTooltip
                                noActions
                                tooltipText={this.tooltipText(event)}
                                tooltipOptions={{
                                  rightAligned:
                                    index > slots.length / 2 ? true : false,
                                }}
                                asyncMoment
                              />
                            </View>
                          );
                        })}
                        {(isHovered || isExpanded) && (
                          <View style={this.styles().slotTooltip}>
                            <Text center trim numberOfLines={1}>
                              |
                            </Text>
                            <Text center trim numberOfLines={1}>
                              {item.date}
                            </Text>
                          </View>
                        )}
                      </View>
                    );
                  }}
                </Hoverable>
              </TouchableWithoutFeedback>
            );
          })}
        </View>
      </View>
    );
  };

  renderChapters = () => {
    let { moments, chapters, chapterSlots, loadingChapters } = this.state;
    if (loadingChapters)
      return (
        <View
          style={{
            width: this.context.sizes.WIDTH,
            justifyContent: "center",
            alignItems: "center",
            height: 100,
          }}
        >
          <ActivityIndicator />
        </View>
      );
    // console.log(moments, chapters);
    return this.renderSlots(chapterSlots);
  };

  tooltipText = (event) => {
    let { value } = this.props;
    let text = "";
    let valueText = event.value?.title || event.value?.text || "";
    if (event.category == "creation") {
      text = "Created";
      if (event.value.id != value.id) {
        text += ` - ${valueText}`;
      }
    } else if (event.category == "completion") {
      text = "Completed";
      if (event.value.id != value.id) {
        text += ` - ${valueText}`;
      }
    } else if (event.category == "progress") {
      text = textHelpers.formatTime(event.timestamp);
      if (event.value.id != value.id) {
        text += ` ${valueText}`;
      }
    } else if (event.category == "note") {
      text = valueText;
    }
    return text;
  };

  expandSlot = (slot) => {
    let { expandedDates } = this.state;
    let date = slot.date;
    expandedDates.push(date);
    this.setState({ expandedDates });
  };

  collapseSlot = (slot) => {
    let { expandedDates } = this.state;
    let date = slot.date;
    let index = expandedDates.indexOf(date);
    if (index >= 0) {
      expandedDates.splice(index, 1);
      this.setState({ expandedDates });
    }
  };

  renderTitle = (value, timestampOnly = true) => {
    let text = null;
    let dt = null;
    // console.log(value);
    if (!!value.is_progress || !!value.is_note) {
      dt = timeHelpers.dateTimeToDate(value.completed_at || value.created_at);
      text = timestampOnly ? dt : dt;
    } else if (!!value.completed_at) {
      dt = timeHelpers.dateTimeToDate(value.completed_at);
      text = timestampOnly ? dt : `Completed at ${dt}`;
    } else {
      dt = timeHelpers.dateTimeToDate(value.created_at);
      text = timestampOnly ? dt : `Created at ${dt}`;
    }
    if (!!text) {
      // return <Text button>{text}</Text>;
      return <Text>{text}</Text>;
    }
    return null;
  };

  fetchInheritance = async () => {
    let { value } = this.props;
    if (!this.state.recursive) return;
    this.setState({ fetchingInheritance: true });
    let res = await valueActions.getFamily(value.id, { up: 0, down: 99 });
    this.setState({ fetchingInheritance: false });
  };

  styles = () => ({
    contentRow: {
      flex: 1,
      marginTop: this.context.sizes.giant,
      marginHorizontal: this.context.sizes.base,
      alignSelf: "stretch",
      borderColor: "red",
    },
    header: {
      flexDirection: "row",
      alignSelf: "stretch",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: this.context.sizes.base,
    },
    headerSection: {
      flexDirection: "row",
      alignItems: "center",
    },
    timeline: {
      flexDirection: "row",
      alignItems: "center",
      alignSelf: "stretch",
    },
    line: {
      flex: 1,
      height: 1,
      backgroundColor: this.context.colors.trim,
    },
    timeSlot: {
      flex: 1,
      // flexGrow: 1,
      // flexShrink: 0,
      // minWidth: 30,
      justifyContent: "center",
      alignItems: "center",
      height: 100,
    },
    timeSlotAlt: {
      backgroundColor: colorHelpers.hexToRgbaString(
        this.context.colors.trim,
        0.3,
      ),
    },
    timeSlotHover: {
      backgroundColor: colorHelpers.hexToRgbaString(
        this.context.colors.trim,
        0.9,
      ),
    },
    expandedTimeSlot: {
      minWidth: 250,
      justifyContent: "flex-start",
      alignItems: "flex-start",
      // borderWidth: 1,
      borderColor: "green",
    },
    slotTooltip: {
      position: "absolute",
      top: "100%",
      // top: 0,
      // left: 0,
    },
  });
}
